<svg width="31" height="30" viewBox="0 0 31 30" fill="none" xmlns="http://www.w3.org/2000/svg">
<g id="+/-">
<g id="Group 40131">
<path id="Line 71" d="M26.75 5L5.5 25" stroke="#D85568" stroke-width="3" stroke-linecap="round"/>
<path id="Line 75" d="M19.25 22.5H28" stroke="#D85568" stroke-width="3" stroke-linecap="round"/>
<path id="Line 72" d="M8 3.75V13.75" stroke="#D85568" stroke-width="3" stroke-linecap="round"/>
<path id="Line 73" d="M3 8.75H13" stroke="#D85568" stroke-width="3" stroke-linecap="round"/>
</g>
</g>
</svg>
